import {
	BigNum,
	LEGACY_JUPITER_API,
	SpotMarketConfig,
	SwapClientType,
	SwapMode,
	UnifiedQuoteResponse,
	UnifiedSwapClient,
} from '@drift-labs/sdk';
import { Connection } from '@solana/web3.js';

export const createSwapClient = ({
	clientType,
	connection,
}: {
	clientType: SwapClientType;
	connection: Connection;
}) => {
	return new UnifiedSwapClient({
		clientType,
		connection,
		authToken: '',
		proxyUrl: clientType === 'titan' ? '/api/titan/proxy' : undefined,
		url: clientType === 'jupiter' ? LEGACY_JUPITER_API : undefined,
	});
};

export const getSwapToastId = (
	inMarketIndex: number,
	outMarketIndex: number
) => {
	return `swap-${inMarketIndex}-${outMarketIndex}`;
};

export const calcSwapAmountAtMaxSlippage = (
	isExactIn: boolean,
	quoteDetails: UnifiedQuoteResponse,
	slippage: number,
	swapFromMarket: SpotMarketConfig,
	swapToMarket: SpotMarketConfig
): string => {
	const otherAmount = +(
		(isExactIn ? quoteDetails?.outAmount : quoteDetails?.inAmount) ?? '0'
	);
	const slippageToApply = isExactIn ? 1 - slippage / 100 : 1 + slippage / 100;

	const precision = isExactIn
		? swapToMarket.precision
		: swapFromMarket.precision;
	const precisionExp = isExactIn
		? swapToMarket.precisionExp
		: swapFromMarket.precisionExp;

	const otherAmountAtMaxSlippage = (
		(otherAmount * slippageToApply) /
		(precision.toNumber() ?? 1)
	).toFixed(precisionExp.toNumber() ?? 0);

	return otherAmountAtMaxSlippage;
};

export const getSimulatedQuoteValues = (
	swapAmount: BigNum,
	swapType: SwapMode,
	inputAssetOraclePrice: BigNum,
	outputAssetOraclePrice: BigNum
): {
	swapInAmount: BigNum;
	swapOutAmount: BigNum;
} => {
	const swapOutAmount =
		swapType === 'ExactOut'
			? swapAmount
			: swapAmount.scale(
					inputAssetOraclePrice.toNum() * 10_000,
					outputAssetOraclePrice.toNum() * 10_000
				);

	const swapInAmount =
		swapType === 'ExactIn'
			? swapAmount
			: swapAmount.scale(
					outputAssetOraclePrice.toNum() * 10_000,
					inputAssetOraclePrice.toNum() * 10_000
				);

	return { swapInAmount, swapOutAmount };
};
